import { type AuthHeaderProps } from './auth.types';

export const AuthHeader = ({ title, description, heading: Heading = 'h1', children }: AuthHeaderProps) => {
  return <div className="space-y-4">
    <div className="space-y-2">
      <Heading className="break-words text-2xl font-semibold leading-tight tracking-tight text-gray-900"><span>{title}</span></Heading>
      {description && <p className="text-sm leading-6 text-gray-600"><span>{description}</span></p>}
    </div>
    {children}
  </div>;
};
